import { ECommissionType } from 'shared/types/filters/advanced/commissionType';

export const commissionTypeLabel = {
  [ECommissionType.WithoutDeposit]: 'Без комиссии',
  [ECommissionType.Exclusive]: 'Эксклюзивная',
};
